export default __webpack_public_path__ + "static/media/564abc87729d8774.a6681e3cae14d4626856bc49f847cfc0.svg";